import { MechanicValidator } from './MechanicValidator.ts';
import { PieceTypes } from '@colonist/game-base-types';
import { ArrayUtils } from '@colonist/utils';
import { ActionState, PlayerColor, TileEdgeType } from '@colonist/game-states';
import { getCardsForPiece } from '@colonist/game-card-types';
export class MechanicValidatorRoad extends MechanicValidator {
    getRoadPlayerState(player) {
        if (player == PlayerColor.None) {
            return {
                bankRoadAmount: 0
            };
        }
        const mechanicRoadPlayerState = this.mechanicRoadState[player];
        if (mechanicRoadPlayerState === undefined) throw new Error(`No road player state for player ${player}`);
        return mechanicRoadPlayerState;
    }
    hasResourcesAndPiecesForRoad(player, useResources) {
        const roadPlayerState = this.getRoadPlayerState(player);
        if (roadPlayerState.bankRoadAmount <= 0) return {
            canTakeAction: false,
            errorMessageIfCantTakeAction: {
                key: 'strings:game.errors.notEnoughRoadPieces'
            }
        };
        if (!useResources) return {
            canTakeAction: true
        };
        const resourcesForRoad = getCardsForPiece(PieceTypes.Road);
        const playerController = this.playerValidators.get(player);
        if (playerController == undefined) return {
            canTakeAction: false,
            errorMessageIfCantTakeAction: {
                key: 'strings:game.errors.noPlayer'
            }
        };
        const hasResourcesForRoad = playerController.hasResourceCardsInHand(resourcesForRoad);
        if (!hasResourcesForRoad) return {
            canTakeAction: false,
            errorMessageIfCantTakeAction: {
                key: 'strings:game.errors.notEnoughResources'
            }
        };
        return {
            canTakeAction: true
        };
    }
    canPlayerPlaceRoad(player, useResources) {
        const isSomePlayerDiscarding = this.currentStateValidator.isSomePlayerInActionState(ActionState.SelectCardsToDiscard);
        if (isSomePlayerDiscarding) return {
            canTakeAction: false,
            errorMessageIfCantTakeAction: {
                key: 'strings:game.errors.playersDiscarding'
            }
        };
        const where = this.whereCanPlayerPlaceRoads(player);
        const doesPlayerHaveResourcesAndPiecesForRoad = this.hasResourcesAndPiecesForRoad(player, useResources);
        doesPlayerHaveResourcesAndPiecesForRoad.validHoverLocations = where;
        if (!doesPlayerHaveResourcesAndPiecesForRoad.canTakeAction) return doesPlayerHaveResourcesAndPiecesForRoad;
        if (where.length <= 0) return {
            canTakeAction: false,
            errorMessageIfCantTakeAction: {
                key: 'strings:game.errors.noWhereToPlaceRoad'
            },
            validHoverLocations: where
        };
        return {
            canTakeAction: true,
            validHoverLocations: where
        };
    }
    whereCanPlayerPlaceRoads(player) {
        const placesToBuildRoadArray = [];
        for (const corner of this.mapValidator.tileState.tileCorners){
            if (corner.owner != player) continue;
            if (corner.buildingType == undefined) continue;
            if (this.mapValidator.isCornerKnightAndIsKnightNotTouchingEdgeType(player, corner, TileEdgeType.Road)) continue;
            for (const edge of corner.hexCorner.touchingEdges()){
                const tileEdge = this.mapValidator.tileState.getTileEdge(edge);
                if (tileEdge == undefined) continue;
                if (!this.mapValidator.tileState.isEdgeTouchingLand(tileEdge)) continue;
                if (tileEdge.type != undefined) continue;
                const edgeIndex = this.mapValidator.tileState.getTileEdgeIndex(tileEdge.hexEdge);
                if (edgeIndex == undefined) continue;
                placesToBuildRoadArray.push(edgeIndex);
            }
        }
        for (const edge of this.mapValidator.tileState.tileEdges){
            if (edge.owner != player) continue;
            if (edge.type != TileEdgeType.Road) continue;
            for (const endPoint of edge.hexEdge.endPoints()){
                const tileCorner = this.mapValidator.tileState.getTileCorner(endPoint);
                if (tileCorner == undefined) continue;
                if (tileCorner.owner != undefined) continue;
                for (const touchingEdge of tileCorner.hexCorner.touchingEdges()){
                    const tileEdge = this.mapValidator.tileState.getTileEdge(touchingEdge);
                    if (tileEdge == undefined) continue;
                    if (!this.mapValidator.tileState.isEdgeTouchingLand(tileEdge)) continue;
                    if (tileEdge.type != undefined) continue;
                    const edgeIndex = this.mapValidator.tileState.getTileEdgeIndex(tileEdge.hexEdge);
                    if (edgeIndex == undefined) continue;
                    placesToBuildRoadArray.push(edgeIndex);
                }
            }
        }
        const uniqueRoadLocations = ArrayUtils.removeDuplicatesFromArray(placesToBuildRoadArray);
        const playerController = this.playerValidators.get(player);
        if (playerController == undefined) return uniqueRoadLocations;
        const roadPlayerState = this.getRoadPlayerState(player);
        var _roadPlayerState_restrictedRoadPlacements;
        for (const restrictedPlacement of (_roadPlayerState_restrictedRoadPlacements = roadPlayerState.restrictedRoadPlacements) !== null && _roadPlayerState_restrictedRoadPlacements !== void 0 ? _roadPlayerState_restrictedRoadPlacements : []){
            ArrayUtils.removeElementFromArray(uniqueRoadLocations, restrictedPlacement);
        }
        return uniqueRoadLocations;
    }
    whereCanPlayerPlaceBeginningRoads(player) {
        const placesToBuildRoadArray = [];
        for (const corner of this.mapValidator.tileState.tileCorners){
            if (corner.owner != player) continue;
            if (corner.buildingType == undefined) continue;
            if (!this.mapValidator.areAdjacentEdgesEmpty(corner)) continue;
            for (const edge of corner.hexCorner.touchingEdges()){
                const tileEdge = this.mapValidator.tileState.getTileEdge(edge);
                if (tileEdge == undefined) continue;
                if (!this.mapValidator.tileState.isEdgeTouchingLand(tileEdge)) continue;
                const tileIndex = this.mapValidator.tileState.getTileEdgeIndex(tileEdge.hexEdge);
                if (tileIndex == undefined) continue;
                placesToBuildRoadArray.push(tileIndex);
            }
        }
        return placesToBuildRoadArray;
    }
    constructor(playerValidators, mapValidator, currentStateValidator, mechanicRoadState){
        super(playerValidators, mapValidator);
        this.currentStateValidator = currentStateValidator;
        this.mechanicRoadState = mechanicRoadState;
    }
}
